/** Session flag for in-app WebView: hide site chrome until logout. */
export const APP_VIEW_SESSION_KEY = "vle-app-view";

export function getAppViewQueryParam(search: string): string | null {
  const param = new URLSearchParams(search).get("appView");
  return param || null;
}

export function readAppViewFromSession(): string | null {
  try {
    return sessionStorage.getItem(APP_VIEW_SESSION_KEY);
  } catch {
    return null;
  }
}

export function writeAppViewToSession(mode: string | null): void {
  try {
    if (mode) {
      sessionStorage.setItem(APP_VIEW_SESSION_KEY, mode);
    } else {
      sessionStorage.removeItem(APP_VIEW_SESSION_KEY);
    }
  } catch {
    /* ignore quota / private mode */
  }
}

export function clearAppViewSession(): void {
  writeAppViewToSession(null);
}

/** Remove `appView` from a search string; returns empty string when nothing remains. */
export function stripAppViewFromSearch(search: string): string {
  const params = new URLSearchParams(search);
  if (!params.has("appView")) {
    return search.startsWith("?") ? search.slice(1) : search;
  }
  params.delete("appView");
  return params.toString();
}

export function buildPathnameWithSearch(
  pathname: string,
  search: string,
): string {
  const normalized = search.startsWith("?") ? search.slice(1) : search;
  return normalized ? `${pathname}?${normalized}` : pathname;
}
